<script>
import { UpgradeIcon } from '@thehotelsnetwork/icons/vue/custom';

import { track } from '@/utils/analytics';
import navigate from '@/utils/navigate';
import { premiumLandingUrl } from '@/config/redirectUrls';

export default {
  components: {
    UpgradeIcon,
  },
  props: {
    section: { type: String, default: '' },
  },
  setup(props) {
    const handleUpgradeClick = () => {
      track(`premium - click - ${props.section}`);

      navigate(premiumLandingUrl, { external: true, newTab: true });
    };

    return {
      handleUpgradeClick,
    };
  },
};
</script>

<template>
  <LpButton
    size="small"
    data-testid="trigger"
    class="!bg-unicorn-500 !border-unicorn-500 ml-auto"
    @click="handleUpgradeClick"
  >
    <div class="flex space-x-2 whitespace-nowrap">
      <UpgradeIcon class="w-4 h-4 mt-1 text-white" />
      <span>
        {{ $t('Upgrade now') }}
      </span>
    </div>
  </LpButton>
</template>
